// import logo from './logo.svg';
// import SearchData from "./api_fetch/SearchData";

import "./App.css";
// import ApiFetch from "./InterviewTasks/ApiFetch";

import CustomApiFetch from "./InterviewTasks/CustomApiFetch";

function App() {
  return (
    <>
      <CustomApiFetch />
    </>
  );
}

export default App;
